import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=6ebde5dc&scoped=true&"
import script from "./CatalogSearch.vue?vue&type=script&lang=js&"
export * from "./CatalogSearch.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=6ebde5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebde5dc",
  null
  
)

export default component.exports